import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-1" }
const _hoisted_2 = { class: "mg-b-20" }
const _hoisted_3 = { class: "hint-box flex mg-t-20" }
const _hoisted_4 = { class: "mg-r-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mg-r-20" }, "核算时间", -1)),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateValue) = $event)),
        "value-format": "YYYY-MM",
        type: "month",
        placeholder: "选择日期"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_upload, {
      "file-list": _ctx.fileList,
      "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
      action: _ctx.uploadAction,
      accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      "on-success": _ctx.fileSuccess,
      headers: { Authorization: 'Bearer' + ' ' + _ctx.token },
      "on-error": _ctx.fileEerror,
      "show-file-list": false,
      data: { month: _ctx.dateValue },
      "before-upload": _ctx.handleBeforeUpload
    }, {
      tip: _withCtx(() => _cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "el-upload__tip fc-lightgray mg-l-20" }, " 文件后缀名必须为xlsx，文件大小不得大于10M，最多支持导入1000条数据 ", -1)
      ])),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !_ctx.dateValue
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Upload)
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createTextVNode(" 点击导入 "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["file-list", "action", "on-success", "headers", "on-error", "data", "before-upload"]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hint fc-orange mg-t-20" }, "*文件超过10M或者超过1000条数据", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_icon, { class: "fc-orange" }, {
          default: _withCtx(() => [
            _createVNode(_component_WarningFilled)
          ]),
          _: 1
        })
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createTextVNode("必须填写表头方便后续匹配，也可点击"),
          _createElementVNode("a", {
            class: "fc-blue",
            download: "https://bullet001.51zidan.com/template/excel/acadf588-9da9-4470-923a-96e3a52ef576.xlsx",
            href: "https://bullet001.51zidan.com/template/excel/acadf588-9da9-4470-923a-96e3a52ef576.xlsx"
          }, "下载薪资表模版"),
          _createTextVNode("帮助您快速导入。")
        ]),
        _createElementVNode("div", null, "请核对上传文件首行内容，避免表头错误影响字段匹配。")
      ], -1))
    ])
  ]))
}